export const defaultText =
  '貴社が提供するプロジェクトマネジメントの研修やキャリアアップの機会を活かし、今後は技術者としてだけでなく、マネジメントやプロジェクト推進のスキルも身につけ、ゼネラリストとしてのキャリアを築いていきたいと考えております。';
